import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleX } from '@fortawesome/pro-regular-svg-icons';

import { reorderableListItem } from 'helpers/react_dnd/reorderable_list';
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons';

export type Column = {
  label: string;
  value: string;
};

type ReorderableListItemInjectedProps = {
  connectDragPreview: (el: React.ReactElement) => React.ReactElement;
  connectDragSource: (el: React.ReactElement) => React.ReactElement;
  connectDropTarget: (el: React.ReactElement) => React.ReactElement;
  disabled?: boolean;
  index: number;
  isDragging?: boolean;
  listName?: string;
  onReorder?: (dragIndex: number, hoverIndex: number, group?: string) => void;
  targetGroup?: string;
}

type Props = {
  column: Column;
  onDeselectColumn: () => void;
} & ReorderableListItemInjectedProps;

class SelectedColumnRow extends React.Component<Props> {
  constructor(props) {
    super(props);
  }

  renderDragSource() {
    return this.props.connectDragSource(
      <div className="me-2" style={{ cursor: 'grab' }}>
        <FontAwesomeIcon icon={faGripDotsVertical}/>
      </div>
    );
  }

  render() {
    const {
      column,
      connectDragPreview,
      connectDropTarget,
      isDragging,
      onDeselectColumn
    } = this.props;

    return connectDragPreview(connectDropTarget(
      <div style={{ opacity: isDragging ? 0 : 1 }}>
        <div
          className="d-flex align-items-center justify-content-between rounded border p-2 pe-4"
        >
          <div className="d-flex">
            {this.renderDragSource()}
            {column.label}
          </div>
          <FontAwesomeIcon
            className="clickable text-danger"
            icon={faCircleX}
            onClick={onDeselectColumn}
          />
        </div>
      </div>
    ));
  }
}

export default reorderableListItem(SelectedColumnRow, 'SelectedColumnList', {
  beginDrag(props) {
    return {
      id: props.column.value,
      index: props.index
    };
  }
});
